/** Which collection merchant binding produced a money record (OP-00 D1). A payout is `live` only. */
export const PROVIDER_MODE = ["sandbox", "live"];
/**
 * Who created the link. `placeholder` is the test payment path (DD5-1): an `is_test` attempt, never
 * `live`, never written to a payable book.
 */
export const COLLECTION_PROVIDER_NAME = ["everypay", "placeholder"];
/** `customer_order_payment.state` (DD5-6: no `failed`; `amount_mismatch` is terminal). */
export const CUSTOMER_ORDER_PAYMENT_STATE = [
    "creating",
    "active",
    "paid",
    "amount_mismatch",
    "expired",
    "cancelled",
    "not_created",
];
/** The states the partial unique index `customer_order_payment_one_open` covers (E4). */
export const OPEN_CUSTOMER_ORDER_PAYMENT_STATE = ["creating", "active"];
export const CUSTOMER_ORDER_PAYMENT_ORIGIN = ["conversation", "console", "worker"];
/** `customer_order_refund.state`: `ambiguous` is looked up by its reference, never re-posted. */
export const CUSTOMER_ORDER_REFUND_STATE = ["created", "sent", "ambiguous", "succeeded", "failed"];
export const CUSTOMER_ORDER_REFUND_ORIGIN = ["console", "operator", "late_payment", "provider_dashboard"];
/** `customer_order_refund.requested_by_kind`, and the actor of an SMS or a payable entry. */
export const CUSTOMER_ORDER_REFUND_REQUESTER_KIND = ["person", "operator", "system"];
/** The prefix of every refund reference: written before the call, carried in the provider's metadata. */
export const REFUND_REFERENCE_PREFIX = "wtr-";
export const CUSTOMER_ORDER_DISPUTE_STATE = ["opened", "won", "lost"];
export const CUSTOMER_ORDER_DISPUTE_SOURCE = ["dispute_pass", "operator"];
/** `customer_order_payment_event.kind` — the order's payment timeline (DD5-2), 0038's list verbatim. */
export const CUSTOMER_ORDER_PAYMENT_EVENT_KIND = [
    "link_created",
    "link_delivered",
    "link_delivery_failed",
    "link_resent",
    "link_cancelled",
    "paid",
    "paid_after_method_change",
    "amount_mismatch",
    "expired",
    "not_created",
    "payment_method_changed",
    "marked_paid_elsewhere",
    "refund_requested",
    "refund_succeeded",
    "refund_failed",
    "late_payment_refund",
    "dispute_opened",
    "dispute_won",
    "dispute_lost",
    "sms_accepted",
    "sms_delivered",
    "sms_failed",
    "sms_unknown",
];
/** Who caused a timeline fact. `payer` is the member of the public who paid. */
export const CUSTOMER_ORDER_PAYMENT_EVENT_ACTOR_KIND = ["person", "operator", "system", "payer"];
/**
 * An account's online-payment mode (OP-00 D2), set only by an operator. No `online_payment_setting`
 * row means `off`: online payment is not offered in real conversations.
 */
export const ONLINE_PAYMENT_MODE = ["off", "sandbox", "pilot", "live"];
/** The platform `feature_toggle` code 0038 seeds off (DD5-29): real money for accounts in mode `live`. */
export const ONLINE_PAYMENT_GENERAL_LIVE_TOGGLE = "online_payment_general_live";
//# sourceMappingURL=customer-order-payment.js.map